import { render, staticRenderFns } from "./PatientRecordForm.vue?vue&type=template&id=c6ec2ad0&scoped=true"
import script from "./PatientRecordForm.vue?vue&type=script&lang=js"
export * from "./PatientRecordForm.vue?vue&type=script&lang=js"
import style0 from "./PatientRecordForm.vue?vue&type=style&index=0&id=c6ec2ad0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ec2ad0",
  null
  
)

export default component.exports